import axios, { AxiosResponse } from 'axios';

import { ServerData } from '@/@types/base';

import {
  ApiUserProfileResponse,
  ApiSendFilePayload,
  ApiUserSettingsResponse,
  ApiSetUserSettingsPayload,
  ApiSetUserSettingsResponse,
  ApiSetContactUsPayload,
  ApiContactUsResponse,
} from '@/@types/user';

export async function getUserProfile() {
  const response: AxiosResponse<ServerData<ApiUserProfileResponse>> =
    await axios({
      method: 'GET',
      url: '/user/profile',
    });

  const {
    data: { success, data: user },
  } = response;

  if (!success) {
    throw new Error('api getUserProfile success false');
  }

  return user;
}

export async function sendMessageText(text: string) {
  const response: AxiosResponse<ServerData<null>> = await axios({
    method: 'POST',
    url: '/chat/add-message',
    params: {
      content: text,
    },
  });

  const {
    data: { success },
  } = response;

  if (!success) {
    throw new Error('api sendMessageText success false');
  }
}

export async function sendMessageFile(payload: ApiSendFilePayload) {
  const response: AxiosResponse<ServerData<null>> = await axios({
    method: 'POST',
    url: '/chat/add-message',
    data: payload,
  });

  const {
    data: { success },
  } = response;

  if (!success) {
    throw new Error('api sendMessageFile success false');
  }
}

export async function getUserSettings() {
  const response: AxiosResponse<ServerData<ApiUserSettingsResponse>> =
    await axios({
      method: 'GET',
      url: '/user/user-settings',
    });

  const {
    data: { success, data: settings },
  } = response;

  if (!success) {
    throw new Error('api getUserSettings success false');
  }

  return settings;
}

export async function setUserSettings(payload: ApiSetUserSettingsPayload) {
  const response: AxiosResponse<ServerData<ApiSetUserSettingsResponse>> =
    await axios({
      method: 'POST',
      url: '/user/user-settings',
      data: payload,
    });

  const {
    data: { success, data: updatedSettings },
  } = response;

  if (!success) {
    throw new Error('api setUserSettings success false');
  }

  return updatedSettings;
}

export async function sendContactUs(payload: ApiSetContactUsPayload) {
  const response: AxiosResponse<ServerData<ApiContactUsResponse>> = await axios(
    {
      method: 'POST',
      url: '/email/contact-us',
      data: payload,
    }
  );

  const {
    data: { success, data: contactData },
  } = response;

  if (!success) {
    throw new Error('api sendContactUs success false');
  }

  return contactData;
}
